import { graphql } from 'gatsby'
import React from 'react'
import ContactColumns, {
  ContactColumn,
  ContactColumnLineItem,
  ContactColumnsContent,
} from 'src/components/organisms/general/contactColumns'
import { PrismicPageDataBodyContactColumns } from 'src/typings/generated/graphql'

// TEMP: Use any until the Prismic schema is added and `npm run type-graphql` is run.
type Props = { slice: PrismicPageDataBodyContactColumns }

// The layout supports three fixed columns. Column-level config (title + bottom
// CTA button) lives in `primary`; each repeatable line item is tagged with the
// column it belongs to via the `column` select field ("1" | "2" | "3").
const COLUMN_KEYS = ['1', '2', '3'] as const

const ContactColumnsSlice = ({ slice }: Props) => {
  const primary = slice?.primary ?? {}
  const items = slice?.items ?? []

  const columns: ContactColumn[] = COLUMN_KEYS.map(key => {
    const lineItems: ContactColumnLineItem[] = items
      .filter((item: any) => (item?.column ?? '1') === key)
      .map((item: any) => ({
        title: item?.item_title ?? undefined,
        description: item?.item_description ?? undefined,
        buttonLabel: item?.item_button_label ?? undefined,
        buttonLink: item?.item_button_link ?? undefined,
      }))

    return {
      title: primary[`column_${key}_title`] ?? undefined,
      items: lineItems,
      buttonText: primary[`column_${key}_button_label`] ?? undefined,
      buttonLink: primary[`column_${key}_button_link`] ?? undefined,
    }
  }).filter(
    column => column.items.length > 0 || column.title || column.buttonLink?.url
  )

  const content: ContactColumnsContent = {
    anchor: primary.anchor ?? undefined,
    headline: primary.headline ?? undefined,
    columns,
  }

  return <ContactColumns content={content} />
}

export default ContactColumnsSlice

export const fragmentQuery = graphql`
  fragment PageDataBodyContactColumns on PrismicPageDataBodyContactColumns {
    primary {
      anchor
      headline
      column_1_title
      column_1_button_label
      column_1_button_link {
        ...BasicLinkFragment
      }
      column_2_title
      column_2_button_label
      column_2_button_link {
        ...BasicLinkFragment
      }
      column_3_title
      column_3_button_label
      column_3_button_link {
        ...BasicLinkFragment
      }
    }
    items {
      column
      item_title
      item_description {
        richText
      }
      item_button_label
      item_button_link {
        ...BasicLinkFragment
      }
    }
  }
`
